<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data-idempotent="methods.updateData"
        :method-update-scheme="methods.updateScheme"
      />
    </template>
  </Content>
</template>

<script>
import Form from "@/components/Form";
import Content from "@/layout/Content";

import {
  postSiteSection as createData,
  getSiteSectionID as fetchData,
  patchSiteSection as updateData,
} from "@/api/siteSection";
import { SiteSectionCreate as defaultScheme } from "@/api/schemes/siteSection";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        createData,
        updateData,
        fetchData,
        updateScheme,
      },
    };
  },
};
</script>
